/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 获取重构专题详情
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  id: string,

  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: cms.SubjectInfoDetailDto;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "get",
    url: `/cms/subject-info/${id}/new`,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
